export const isIterableArray = (array: any[]) => Array.isArray(array) && !!array.length;

export const generateRandomCode = (n: number) => {
    let str = ''
    for (let i = 0; i < n; i++) {
        str += Math.floor(Math.random() * 10)
    }
    return str
}